export default "__VITE_ASSET__188aa42f__"